export const variables = {
  //  API_URL:"https://localhost:7057"
    API_URL:"https://csassetinfoapi.azurewebsites.net/"
}


export const styles = {
    PADDING:'8px'
}